var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submitBtnContainer"},[_c('Presentational',{attrs:{"btnText":_vm.value},on:{"entry":_vm.entry}}),(_vm.onOverlay)?_c('LoadingContainer',{class:{ overlay: true }}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }